import { Category } from "../model/model";
import { MarketSavedSearchClient } from "./MarketSavedSearchClient";
import { FlightSavedSearchClient } from "./FlightSavedSearchClient";
import { HolidayRentalSavedSearchClient } from "./HolidayRentalSavedSearchClient";
import { SavedSearchClient } from "../model/SavedSearchClient";

export class SavedSearchClientFactory {
  static getClient(category: Category): SavedSearchClient {
    switch (category) {
      case Category.MARKET:
        return new MarketSavedSearchClient();
      case Category.FLIGHT:
        return new FlightSavedSearchClient();
      case Category.HOLIDAY_RENTAL:
        return new HolidayRentalSavedSearchClient();
      default:
        throw new Error(`Unsupported Saved Search modal category: ${category}`);
    }
  }
}
